import React from 'react';
import {German} from "./languages/German";
import {initialGuestUser} from "../models/users/AuthenticatedUser";
import {MapByStr} from "../models/common/Map";
import {InputValueLockType, RemoveInputValueLock} from "../models/common/InputValueLockType";

/**
 * When user is logged in and has chosen a language.
 * The file App.tsx provides the context to all Children.
 */
export const LanguageContext = React.createContext(German);

/**
 * every view provides a viewIdentifier
 * this identifier is important for UserViewSettings, FormData and a lot of other functionality
 * to make access easier than passing the viewIdentifier down through every component, a context is created
 *
 * to provide the context to all child components you should use at top level of your view render function
 * @see ContentContextContainer
 */
export const ViewIdentifierContext = React.createContext( "dashboard" );

/**
 * many components rely on the authenticated user to check if the currently logged in user has the
 * required permissions to access a resource. to make access to the authenticated user easier,
 * ContentContextContainer will provide the authenticated user to the child components.
 *
 * @see ContentContextContainer
 */
export const AuthenticatedUserContext = React.createContext( initialGuestUser() );

/**
 * InputLockedValuesContext provides easy access to locked values in form input fields.
 */
export const InputLockedValuesContext = React.createContext<InputValueLockType & RemoveInputValueLock>( {
    isInputValueLockSelectable: false,
    hasLockedValues: false,
    values: {},
    onRemoveInputLock: ( key: string ) => { console.log( "not implemented!") }
} );

/**
 * keeps track of the state of currently selected tab
 *
 * @see TabBar
 * @see TabContent
 */
export const TabIndexContext = React.createContext({ selectedTabIndex: 0 });

/**
 * keeps track of the current window size
 */
export const WindowSizeContext = React.createContext({ height: 0, width: 0 });